import React from "react";
import ModalInput from "../ModalInput";
import {convertJSONintoPreferredTryOutFormat} from "../../utils/tryOutUtils";
import {useMyContext} from "../../context/MyContext";

function ParameterContainer({inputValues, onInputChange}) {
  const {setIsExecute, method} = useMyContext();
  const {Headers, PathParameters, QueryParameters, RequestBody} =
    convertJSONintoPreferredTryOutFormat(method);

  const buttonClick = ()=>{
    setIsExecute(true);
  };
  const handleFileInputChange = (property, event) => {
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);
    onInputChange("Body", formData);
  };

  const handleInputChange = (event) => {
    onInputChange("Body", event.target.value);
  };

  const requestBodyParams = method?.requestBody;
  const content = requestBodyParams?.content;
  const contentTypeHeader = Headers.find((header) => header?.name?.toLowerCase() === "content-type");
  const isJSONContent = contentTypeHeader && contentTypeHeader?.value?.toLowerCase().includes("application/json");

  const properties = RequestBody?.content?.["multipart/form-data"]?.schema?.value?.properties;

  return (
    <div id="tryout-parameter-container" data-testid={"tryout-parameter-container"} className="tryout-parameter-container">
      {PathParameters.length > 0 && (
        <div id="tryout-parameter-path" className="tryout-parameter-path margin-10">
          <div className="heading">Path Parameters</div>
          {PathParameters.map((parameter, index) => (
            <ModalInput key={index} parameter={parameter} onInputChange={onInputChange} value={inputValues[parameter.name]} />
          ))}
        </div>
      )}
      {QueryParameters.length > 0 && (
        <div id="tryout-parameter-path" className="tryout-parameter-path margin-10">
          <div className="heading">Query Parameters</div>
          {QueryParameters.map((parameter, index) => (
            <ModalInput key={index} parameter={parameter} onInputChange={onInputChange} value={inputValues[parameter.name]} />
          ))}
        </div>
      )}
      {Headers.length > 0 && (
        <div id="tryout-parameter-path" className="tryout-parameter-path margin-10">
          <div className="heading">Header Parameters</div>
          {Headers.map((parameter, index) => (
            <ModalInput key={index} parameter={parameter} onInputChange={onInputChange} value={inputValues[parameter.name]} />
          ))}
        </div>
      )}
      {RequestBody && Object.keys(RequestBody).length !== 0 && (
        <div id="tryout-parameter-body" className="tryout-parameter-body margin-10">
          <div className="heading">Request Body</div>
          {isJSONContent ? (
            // Render textarea for application/json content type
            <div id="tryout-parameter-body-content" className="tryout-parameter-body-content margin-10">
              <div>
                <label id="tryout-parameter-body-label-data" className="tryout-parameter-body-label">data</label>
                <textarea
                  id="tryout-parameter-body-text"
                  className="tryout-parameter-body-text"
                  onChange={handleInputChange}
                  value={inputValues["Body"] || ""}
                />
              </div>
            </div>
          ) : (
            // Render file upload logic for other content types
            <div id="tryout-parameter-body-content" className="tryout-parameter-body-content margin-10">
              {Object.entries(properties).map(([propertyName, propertyDetails]) => (
                <div key={propertyName}>
                  <label className="tryout-parameter-body-label">{propertyName}</label>
                  {propertyDetails.format === "binary" ? (
                    <input id="fileInput" type="file" accept="application/pdf" onChange={(e) => handleFileInputChange(propertyName, e)}/>
                  ) : (
                    <input type="text" placeholder={`Enter ${propertyName}`} />
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      <div className="tryout-parameter-action">
        <button id="execute-button" className="execute-button" onClick={buttonClick} >
          <span>Execute</span>
        </button>
      </div>
    </div>
  );
}

export default ParameterContainer;
